// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { viewStyles } from "@west/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { DivWrapper } from "@west/XDL/constants";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

viewStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 430px 1fr 1fr 317px;
        grid-template-rows: auto 1fr;
        grid-column-gap: 0;
        width: 100%;
        @media print {
            width: 100%;
            content: "";
            display: table;
            clear: both;
        }

        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr 1fr;
        }

        ${xScreen("lte", "xs")} {
            grid-template-columns: 1fr;
        }
    `,
};

viewStyles.imageContainer = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 3;
        margin-bottom: 8px;

        & > ${DivWrapper} {
            display: flex;
            flex-direction: column;
            gap: 16px;
            width: 100%;
        }

        ${xScreen("lte", "md")} {
            grid-column: 1 / 2;
            grid-row: 2 / 3;
            margin-bottom: 32px;
        }

        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 2 / 3;
        }
    `,
};

viewStyles.titleContainer = {
    css: css`
        grid-column: 2 / 4;
        grid-row: 1 / 2;
        position: relative;
        padding: 0 22px;

        @media print {
            padding: 0;
        }

        > div {
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 1px solid ${getColor("common.border")};

            ${xScreen("lte", "md")} {
                padding-bottom: 0;
                margin-bottom: 0;
                border-bottom: 0;
            }
        }

        ${xScreen("lte", "md")} {
            grid-column: 1 / 2;
            grid-row: 1 / 2;
            padding: 0;
            margin-bottom: 16px;
            border-bottom: 0;
        }

        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 1 / 2;
        }
    `,
};
viewStyles.descriptionContainer = {
    css: css`
        grid-column: 2 / 4;
        grid-row: 2 / 3;
        position: relative;
        padding: 0 22px;

        @media print {
            padding: 0;
        }

        ${xScreen("lte", "md")} {
            grid-column: 1 / 2;
            grid-row: 3 / 4;
            padding: 0;
        }

        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 4 / 5;
        }
    `,
};
viewStyles.actionsContainer = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 1 / 4;

        ${xScreen("lte", "md")} {
            grid-column: 2 / 3;
            grid-row: 1 / 5;
            max-width: 358px;
            margin-left: auto;
        }

        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 3 / 4;
            margin-bottom: 32px;
            margin-left: initial;
            max-width: initial;
        }
    `,
};

viewStyles.bottomContainer = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 3 / 4;
        position: relative;
        margin-top: 32px;
        padding-right: 22px;

        ${xScreen("lte", "md")} {
            grid-column: 1 / 2;
            grid-row: 4 / 5;
            margin-top: 0;
            padding-right: 0;
        }

        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 5 / 6;
        }
    `,
};

viewStyles.actionBoxContainer = {
    css: css`
        padding: 13px;
        border-radius: 2px;
        border: 1px solid ${getColor("common.border")};
        & > ${DivWrapper} {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    `,
};

viewStyles.extraContainer = {
    css: css`
        grid-column: 1 / 5;
        grid-row: 4 / 5;
        ${xScreen("lte", "md")} {
            grid-row: 5 / 6;
        }

        ${xScreen("lte", "xs")} {
            grid-row: 6 / 7;
        }
    `,
};
